module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-fff page-flex"
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-input-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "alifont icon-back left-icon click",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryKey),
      expression: "queryKey"
    }],
    staticClass: "center-input fs-28",
    attrs: {
      "type": "search",
      "placeholder": "搜索订单(手机号、订单号、顾客)"
    },
    domProps: {
      "value": (_vm.queryKey)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right fs-28 color-333 click",
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("\n            搜索\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-30 flex-between flex-center pd-025"
  }, [_c('div', {
    staticClass: "fs-32 color-333 font-bold"
  }, [_vm._v("最近搜索")]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 click",
    on: {
      "click": _vm.clean
    }
  }, [_vm._v("清空记录")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 word-list pd-025"
  }, _vm._l((_vm.historyList), function(item, $index) {
    return _c('div', {
      staticClass: "word-item click",
      on: {
        "click": function($event) {
          _vm.queryKey = item;
          _vm.handleQuery()
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d7cbf6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/locker/search.vue
// module id = 6YWa
// module chunks = 51